


































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { modes } from '@/utils/constants';
import { mapState } from 'vuex';
import Select from '@/components/fields/Select.vue';
import PartnersList from '@/components/PartnersList.vue';
import InvitationsList from "@/components/InvitationsList.vue";
import { NetworkInvitation, PartnerType } from 'types';

@Component({
    computed: {
        ...mapState(['mode', 'structures'])
    },
    components: {
        InvitationsList,
        PartnersList,
        Select
    }
})
export default class AddConnection extends Vue {
    subjectConnectionInfo: { invitations?: [] } = {};
    selectedSubjectConnection: { uuid?: string; } = {};
    subjectOrganisation: { uuid?: string; } = {};
    subjectBranches = [];

    targetConnectionInfo: { invitations?: [] } = {};
    selectedTargetConnection: { uuid?: string; } = {};
    targetOrganisation: { uuid?: string; } = {};
    targetBranches = [];
    targetConnectionType = '';

    invitationsToDelete: NetworkInvitation[] = [];

    modes = modes;
    structures!: any;
    mode!: string;

    updatingNetworks = false;

    getOwnerName(connection: Record<string, any>) {
        const {name, firstName, lastName} = connection;

        return name || `${firstName} ${lastName}`.trim();
    }

    getConnectionName(connection: Record<string, any>) {
        const { additionalInfo } = connection;
        if (additionalInfo) {
            const { ORGANIZATION_NAME, BRANCH_NAME, FIRST_NAME, LAST_NAME } = additionalInfo;

            return BRANCH_NAME || ORGANIZATION_NAME || `${FIRST_NAME} ${LAST_NAME}`;
        } else {
            return this.getOwnerName(connection);
        }
    }


    isBranchMode(mode: string) {
        return mode && mode.includes('BRANCH');
    }

    getTitle(mode: PartnerType) {
        const currentMode = modes.find(variant => variant.value === mode);
        if (!currentMode) return '';
        return currentMode.title;
    }

    getSelectLabel(mode: string) {
        if (mode.includes('EA') || mode.includes('CONV')) return 'name';
        return 'email';
    }

    getSelectPlaceholder(mode: string) {
        if (mode.includes('EA') || mode.includes('CONV')) return 'Start typing name';
        return 'Start typing email';
    }

    getNetworkByUuid(uuid: string, field: 'subjectConnectionInfo' | 'targetConnectionInfo') {
        if (!uuid) return;

        this.$store.dispatch('getNetworkByUuid', uuid).then(({ data }) => {
            const { invitations, ownerUuid } = data;

            let response;

            if (invitations) {
                response = {
                    ...data,
                    invitations: invitations.map((i: NetworkInvitation) => ({
                        ...i,
                        ownerUuid
                    }))
                };
            } else {
                response = data;
            }

            this[field] = response;
        });
    }

    enrichInvitationsWithOwner(invitationsList: NetworkInvitation[], ownerInfo: Record<string, any>) {
        return invitationsList.map((i: any) => {
            if (!i) return;
            return { ...i, ownerName: this.getOwnerName(ownerInfo) };
        });
    }

    get invitationsList() {
        const {
                subjectConnectionInfo: { invitations: subjectInvitations = [] },
                targetConnectionInfo: { invitations: targetInvitations = [] },
                selectedTargetConnection,
                selectedSubjectConnection
            } = this,
            invitationsList: NetworkInvitation[] = [];

        invitationsList.push(
            ...this.enrichInvitationsWithOwner(subjectInvitations, selectedSubjectConnection),
            ...this.enrichInvitationsWithOwner(targetInvitations, selectedTargetConnection)
        );
        return invitationsList;

    }

    @Watch('selectedSubjectConnection.uuid')
    handleSubjectConnection(uuid: string) {
        this.getNetworkByUuid(uuid, 'subjectConnectionInfo');
    }

    @Watch('selectedTargetConnection.uuid')
    handleTargetConnection(uuid: string) {
        this.getNetworkByUuid(uuid, 'targetConnectionInfo');
    }

    @Watch('targetConnectionType')
    handleTargetConnectionTypeChange(targetConnectionType: string) {
        if (!targetConnectionType) return;

        this.clearTargetSelection(true);

        if (!this.structures[targetConnectionType].length) {
            this.$store.dispatch('loadStructures', targetConnectionType);
        }
    }

    @Watch('subjectOrganisation', { deep: true })
    handleOrgUuidChange(subjectOrganisation: Record<string, unknown>) {
        if (subjectOrganisation && subjectOrganisation.uuid) {
            const { uuid } = subjectOrganisation;

            this.clearSubjectSelection();

            this.$store.dispatch('loadBranches', { mode: this.mode, uuid })
                .then(({ data }) => this.subjectBranches = data);
        }
    }

    @Watch('targetOrganisation', { deep: true })
    handleTargetOrgUuidChange(targetOrganisation: Record<string, unknown>) {
        if (targetOrganisation && targetOrganisation.uuid) {
            const { uuid } = targetOrganisation;

            this.clearTargetSelection();

            this.$store.dispatch('loadBranches', { mode: this.targetConnectionType, uuid })
                .then(({ data }) => this.targetBranches = data);
        }
    }

    mounted() {
        const { mode, structures } = this;

        if (!structures[mode].length) {
            this.$store.dispatch('loadStructures', mode);
        }
    }

    setConnectionEntity(
        field: 'selectedSubjectConnection' | 'selectedTargetConnection' | 'subjectOrganisation' | 'targetOrganisation',
        entity: Record<string, any>
    ) {
        this[field] = {
            ...entity,
            uuid: entity.uuid || entity.organizationUuid
        };
    }

    selectConnectionMode(mode: string) {
        this.targetConnectionType = mode;
    }

    handleInvitationsSelect(invitation: NetworkInvitation) {
        const { invitationsToDelete } = this;

        if (invitationsToDelete.find(i => i.invitedEmail === invitation.invitedEmail)) {
            // remove invitation from list as it already exists

            this.invitationsToDelete = this.invitationsToDelete.filter(i => i.invitedEmail !== invitation.invitedEmail);
        } else {
            // add invitation
            this.invitationsToDelete = [...this.invitationsToDelete, invitation];
        }
    }

    convertInvitationsToDelete() {
        if (!this.invitationsToDelete.length) return [];

        const invitationsList = this.invitationsToDelete.reduce((acc: any, curr) => {
            const { ownerUuid, invitedEmail } = curr;

            return {
                ...acc,
                [ownerUuid]: {
                    ownerUuid,
                    invitations: acc[ownerUuid] && acc[ownerUuid].invitations
                        ? [...acc[ownerUuid].invitations, { invitedEmail }]
                        : [{ invitedEmail }]
                }
            };

        }, {});

        return Object.values(invitationsList);
    }

    clearTargetSelection(deep?: boolean) {
        this.targetBranches = [];
        this.targetConnectionInfo = {};
        this.selectedTargetConnection = {};
        if (deep) {
            this.targetOrganisation = {};
        }
    }

    clearSubjectSelection() {
        this.subjectBranches = [];
        this.subjectConnectionInfo = {};
        this.selectedSubjectConnection = {};
    }

    addConnection() {
        const { selectedSubjectConnection, selectedTargetConnection, mode, targetConnectionType } = this,
            { dispatch } = this.$store,
            subjectConnection: Record<string, unknown> = {
                type: mode,
                uuid: selectedSubjectConnection.uuid
            },
            targetConnection: Record<string, unknown> = {
                type: targetConnectionType,
                uuid: selectedTargetConnection.uuid
            };

        if (this.isBranchMode(mode)) {
            subjectConnection.organizationUuid = this.subjectOrganisation.uuid;
        }

        if (this.isBranchMode(targetConnectionType)) {
            targetConnection.organizationUuid = this.targetOrganisation.uuid;
        }

        this.updatingNetworks = true;

        dispatch('discardInvitation', JSON.stringify(this.convertInvitationsToDelete()))
            .then(() => dispatch('addConnection', [subjectConnection, targetConnection]))
            .then(() => dispatch('getNetworkByUuid', selectedSubjectConnection.uuid))
            .then(({ data }) => this.subjectConnectionInfo = data)
            .finally(() => {
                this.updatingNetworks = false;
                this.targetConnectionType = '';

                this.clearTargetSelection(true);
            });
    }

    openRemoveConnectionModal(partnerUuid: string, partnerName: string, connectionUuid: string, connectionName: string) {
        const { commit } = this.$store;

        commit('setModalMode', 'remove-connection');
        commit('setModalData', {
            partnerUuid,
            partnerName,
            connectionName,
            connectionUuid,
            successCallback: this.removeConnectionCallback
        });
        commit('toggleModal');
    }

    removeConnectionCallback(connectionUuid: string) {
        const { dispatch } = this.$store;

        dispatch('getNetworkByUuid', connectionUuid).then(({ data }) => {
            this.subjectConnectionInfo = data;
        });
    }

    discardInvitation(ownerUuid: string, invitedEmail: string) {
        const body = [
                {
                    ownerUuid,
                    invitations: [
                        { invitedEmail }
                    ]
                }
            ],
            { dispatch } = this.$store,
            { selectedSubjectConnection: { uuid } } = this;

        dispatch('discardInvitation', JSON.stringify(body)).then(res => {
            if (res && res.status === 200) {
                dispatch('getNetworkByUuid', uuid).then(({ data }) => this.subjectConnectionInfo = data);
            }
        });
    }
}
